module.exports = __webpack_public_path__ + "img/metaverse.e0ae7990.png";